import {
  OPERATOR_CONSTANTS,
  MATCH_TYPE_CONTANTS,
  ACTION_CONTANTS,
} from './ConditionalRenderingContants'

export const checkConditions = (fieldValues: any, conditions: any) => {
  let shouldHide: boolean = false;

  for (let i = 0; i < conditions.length; i += 1) {
    shouldHide = matchingTypes(fieldValues, conditions[i])

    if (shouldHide) {
      break
    }
  }

  return shouldHide;
}

const handleActionType = (actionType, value) => {
  const actions = {
    [ACTION_CONTANTS['SHOW']]: () => {
      return !value
    },
    [ACTION_CONTANTS['HIDE']]: () => {
      return value
    },
  }

  return actions[actionType]()
}

const validate = (operator, value, valueAgainst) => {
  const operators = {
    [OPERATOR_CONSTANTS['IS_EQUAL_TO']]: () => {
      // valueAgainst string needs to be converted to boolean if it's coming from a checkbox
      const compareAgainst = valueAgainst === 'true' ? true : valueAgainst
      return value == compareAgainst
    },
    [OPERATOR_CONSTANTS['IS_NOT_EQUAL_TO']]: () => {
      if (!value) {
        return false
      }

      return value !== valueAgainst
    },
  }

  if (typeof operators[operator] === 'undefined') {
    return false
  }

  return operators[operator]()
}

const matchingTypes = (fieldValues, item) => {
  const matches = {
      [MATCH_TYPE_CONTANTS['ANY']]: (fieldValues, item) => {
        let shouldHide

        for (let i = 0; i < item.conditions.length; i += 1) {
          const value = fieldValues[item.conditions[i].fieldId],
            operator = item.conditions[i].operatorId,
            valueAgainst = item.conditions[i].value

          shouldHide = validate(operator, value, valueAgainst)

          if (shouldHide) {
            break
          }
        }

        return shouldHide
      },
      [MATCH_TYPE_CONTANTS['ALL']]: (fieldValues, item) => {
        let shouldHide

        for (let i = 0; i < item.conditions.length; i += 1) {
          const value = fieldValues[item.conditions[i].fieldId],
            operator = item.conditions[i].operatorId,
            valueAgainst = item.conditions[i].value

          shouldHide = validate(operator, value, valueAgainst)

          if (!shouldHide) {
            break
          }
        }

        return shouldHide
      },
    },
    result = matches[item.matchTypeId](fieldValues, item)

  return handleActionType(item.actionTypeId, result)
}
